/* La Colecție — CTA buttons without a link scroll to the size selector. */
(() => {
  if (window.lcScrollBuyReady) return;
  window.lcScrollBuyReady = true;

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest('[data-lc-scroll-buy]');
    if (!trigger) return;

    const target = document.querySelector('.lc-variants') || document.querySelector('.lc-hero');
    if (!target) return;

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
